
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/matches/success",
      function () {
        return require("private-next-pages/candidate/matches/success/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/matches/success"])
      });
    }
  